export const Names = [
  "亮",
  "佑",
  "修",
  "健",
  "優",
  "光",
  "凪",
  "剛",
  "功",
  "勇",
  "勉",
  "勝",
  "勲",
  "匠",
  "匡",
  "博",
  "奏",
  "学",
  "実",
  "岳",
  "崇",
  "弘",
  "律",
  "徹",
  "怜",
  "悠",
  "想",
  "慧",
  "慶",
  "新",
  "旭",
  "昇",
  "明",
  "昭",
  "昴",
  "晴",
  "暖",
  "朔",
  "樹",
  "正",
  "武",
  "浩",
  "淳",
  "清",
  "渉",
  "湊",
  "玄",
  "碧",
  "稔",
  "空",
  "竜",
  "翔",
  "翼",
  "聡",
  "航",
  "茂",
  "葵",
  "蒼",
  "蓮",
  "誠",
  "諒",
  "豊",
  "輝",
  "進",
  "遼",
  "陸",
  "陽",
  "隆",
  "颯",
  "駿",
  "一心",
  "一男",
  "一輝",
  "一郎",
  "一颯",
  "三郎",
  "亮太",
  "伊吹",
  "伊織",
  "健一",
  "健人",
  "健太",
  "健斗",
  "優太",
  "優斗",
  "優真",
  "勝利",
  "博之",
  "和也",
  "和夫",
  "和彦",
  "哲也",
  "大介",
  "大和",
  "大地",
  "大晴",
  "大智",
  "大樹",
  "大翔",
  "大誠",
  "大貴",
  "大輔",
  "大輝",
  "大雅",
  "太一",
  "太陽",
  "奏佑",
  "奏多",
  "奏太",
  "奏斗",
  "奏汰",
  "幸雄",
  "康平",
  "律希",
  "悠人",
  "悠太",
  "悠希",
  "悠斗",
  "悠生",
  "悠真",
  "悠翔",
  "拓也",
  "拓哉",
  "拓海",
  "新太",
  "昭一",
  "昭三",
  "昭二",
  "晴斗",
  "晴翔",
  "智也",
  "朝陽",
  "正一",
  "正三",
  "正二",
  "正夫",
  "正治",
  "正男",
  "正雄",
  "武雄",
  "歩夢",
  "洋平",
  "浩一",
  "浩之",
  "浩二",
  "海斗",
  "海翔",
  "涼太",
  "湊人",
  "湊大",
  "湊斗",
  "琉生",
  "瑛太",
  "瑛斗",
  "直人",
  "直樹",
  "碧斗",
  "祐介",
  "秀樹",
  "秀雄",
  "竜也",
  "結人",
  "結斗",
  "結翔",
  "絢斗",
  "義雄",
  "翔太",
  "翔平",
  "英樹",
  "葵翔",
  "蒼大",
  "蒼太",
  "蒼生",
  "蒼真",
  "蒼空",
  "蒼翔",
  "貴大",
  "辰男",
  "辰雄",
  "達也",
  "遥斗",
  "陸斗",
  "陽向",
  "陽大",
  "陽太",
  "陽斗",
  "陽翔",
  "雄大",
  "雄太",
  "颯人",
  "颯太",
  "颯汰",
  "颯真",
  "龍生",
  "健太郎",
]
